export const billingMenuDeprecatedRouteMap = {
  "/customers/:customerId/billing-profiles": "/customers/:customerId/billing/billing-profiles",
  "/customers/:customerId/contracts": "/customers/:customerId/billing/contracts",
  "/customers/:customerId/contracts/contracts-list/create": "/customers/:customerId/billing/contracts/create",
  "/customers/:customerId/contracts/contracts-list/:contractId": "/customers/:customerId/billing/contracts/:contractId",
  "/customers/:customerId/contracts/contracts-list/:contractId/view":
    "/customers/:customerId/billing/contracts/:contractId/view",
  "/customers/:customerId/contracts/contracts-list/:contractId/view-vendor-contract":
    "/customers/:customerId/billing/contracts/:contractId/view-vendor-contract",

  // "contracts-list" is a redundant path.
  "/customers/:customerId/contracts/contracts-list": "/customers/:customerId/billing/contracts",
  "/customers/:customerId/billing/contracts/contracts-list": "/customers/:customerId/billing/contracts",

  "/customers/:customerId/isv-solutions": "/customers/:customerId/billing/isv-marketplace",
  "/customers/:customerId/isv-solutions/create": "/customers/:customerId/billing/isv-marketplace/create",
  "/customers/:customerId/isv-solutions/edit/:perkId": "/customers/:customerId/billing/isv-marketplace/edit/:perkId",
  "/customers/:customerId/isv-solutions/:perkId": "/customers/:customerId/billing/isv-marketplace/:perkId",

  "/customers/:customerId/invoices": "/customers/:customerId/billing/invoices",
  "/customers/:customerId/invoices/:eid/:ivnum": "/customers/:customerId/billing/invoices/:eid/:ivnum",

  "/customers/:customerId/adjustments": "/customers/:customerId/billing/adjustments",

  "/customers/:customerId/credits": "/customers/:customerId/billing/credits",
  "/customers/:customerId/orders": "/customers/:customerId/billing/orders",

  "/customers/:customerId/entities/:entityId/edit": "/customers/:customerId/billing/billing-profiles/:entityId/edit",
  "/customers/:customerId/entities/:entityId/:tab?": "/customers/:customerId/billing/billing-profiles/:entityId/:tab?",
  "/customers/:customerId/entities": "/customers/:customerId/billing/billing-profiles",
};
